<template>
  <ion-app>
    <!-- Hauptinhalt -->
    <router-view @showError="showError" />
    <!-- Toast für Fehlermeldungen -->
    <ion-toast
        :is-open="showToast"
        :message="errorMessage"
        duration="3000"
        color="danger"
        @didDismiss="showToast = false"
    ></ion-toast>
  </ion-app>
</template>

<script>

import {
  IonApp,
  IonToast
} from '@ionic/vue';


export default {
  name: 'App',
  components: {
    IonApp,
    IonToast
  },

  data() {
    return {
      showToast: false,
      errorMessage: '',
    };
  },
  methods: {
    showError(message) {
      this.errorMessage = message;
      this.showToast = true;
    },
  },
};
</script>

<style scoped>
</style>
